import LocationGroup from 'src/models/location/LocationGroup'
import Model, { encoders, ID, Integer, MODEL_LEVEL } from 'src/models/model'
import Librariable from 'src/models/model/concerns/Librariable'
import SeatChart from 'src/models/screen/SeatChart'
import PriceCard from 'src/models/showing/PriceCard'
import Showing from 'src/models/showing/Showing'
import ShowingBadge from 'src/models/showing/ShowingBadge'

export default class Screen extends Model {
  static name = 'Screen'

  static isConfiguration = true

  static paginate = true

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Auditorium]

  static define () {
    this.concerns = [Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      number: {
        type: Integer,
        default: 999
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      locationGroup: {
        type: LocationGroup,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },
      overridePriceCard: {
        type: Boolean,
        default: false
      },
      customPriceCard: {
        type: PriceCard,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },
      startOffsetMinutes: {
        type: Integer,
        default: 0
      },
      seatCount: {
        type: Integer,
        default: 0
      },
      heldSeatCount: {
        type: Integer,
        default: 0
      },
      marathonSeatCount: {
        type: Integer,
        default: 0
      },
      reservedSeating: {
        type: Boolean,
        default: false
      },
      seatChart: {
        type: SeatChart,
        encode: encoders.hasOne
      },
      showingBadges: {
        type: [ShowingBadge],
        default: () => { return [] },
        reference: true
      },
      preStartTimeBufferMinutes: {
        type: Integer,
        default: 10
      },
      postStartTimeBufferMinutes: {
        type: Integer,
        default: 10
      },
      postShowingBufferMinutes: {
        type: Integer,
        default: 10
      },
      todaysShowings: {
        type: [Showing],
        default: () => { return [] },
        reference: true,
        output: true
      },
      color: {
        type: String
      },
      overrideMaxTicketsPerOrderPerShowing: {
        type: Boolean,
        default: false
      },
      maxTicketsPerOrderPerShowing: {
        type: Integer,
        default: 10
      }
    }

    this.fragments = {
      select: ['id', 'name', 'color'],
      scheduler: [
        'id', 'name', 'color', 'overridePriceCard',
        'preStartTimeBufferMinutes', 'postStartTimeBufferMinutes', 'postShowingBufferMinutes', 'startOffsetMinutes',
        'seatCount', 'heldSeatCount', 'marathonSeatCount', 'reservedSeating'
      ]
    }
  }

  get computedShowingBadges () {
    return _([
      this.showingBadges?.data,
      [this.reservedSeating ? this.configuration.currentCircuit.reservedSeatingShowingBadge : null]
    ]).flatten().compact().uniqBy('id').sortBy('displayOrder').value()
  }
}
